import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 15V5a2 2 0 0 0-2-2H9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 21h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 17v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m2 2 20 20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MonitorOff";
const MonitorOff = memo(themed(Icon));
export {
  MonitorOff
};
//# sourceMappingURL=monitor-off.js.map
